import { useState } from 'react';
import { X, Copy } from 'lucide-react';
import { colors } from '../../styles/colors';

/**
 * Modal de copie des charges entre années
 */
function CopyChargesModal({ show, onClose, onCopy }) {
  const [copyFromYear, setCopyFromYear] = useState('');
  const [copyToYear, setCopyToYear] = useState('');

  if (!show) return null;

  const handleSubmit = async () => {
    await onCopy(copyFromYear, copyToYear);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        padding: '2rem',
        width: '90%',
        maxWidth: '400px'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem'
        }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: colors.primary.gray, margin: 0 }}>
            Copier les charges
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: colors.secondary.mediumGray
            }}
          >
            <X size={24} />
          </button>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{
            display: 'block',
            marginBottom: '0.5rem',
            fontSize: '0.875rem',
            fontWeight: '500',
            color: colors.primary.gray
          }}>
            Depuis l'année
          </label>
          <select
            value={copyFromYear}
            onChange={(e) => setCopyFromYear(e.target.value)}
            style={{
              width: '100%',
              padding: '0.5rem',
              border: `1px solid ${colors.secondary.lightGray}`,
              borderRadius: '0.25rem',
              fontSize: '0.875rem'
            }}
          >
            <option value="">-- Sélectionner --</option>
            {[...Array(10)].map((_, i) => {
              const year = new Date().getFullYear() - 5 + i;
              return <option key={year} value={year}>{year}</option>;
            })}
          </select>
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{
            display: 'block',
            marginBottom: '0.5rem',
            fontSize: '0.875rem',
            fontWeight: '500',
            color: colors.primary.gray
          }}>
            Vers l'année
          </label>
          <select
            value={copyToYear}
            onChange={(e) => setCopyToYear(e.target.value)}
            style={{
              width: '100%',
              padding: '0.5rem',
              border: `1px solid ${colors.secondary.lightGray}`,
              borderRadius: '0.25rem',
              fontSize: '0.875rem'
            }}
          >
            <option value="">-- Sélectionner --</option>
            {[...Array(10)].map((_, i) => {
              const year = new Date().getFullYear() - 5 + i;
              return <option key={year} value={year}>{year}</option>;
            })}
          </select>
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: colors.secondary.mediumGray,
              color: 'white',
              border: 'none',
              borderRadius: '0.25rem',
              cursor: 'pointer',
              fontSize: '0.875rem'
            }}
          >
            Annuler
          </button>
          <button
            onClick={handleSubmit}
            style={{
              padding: '0.5rem 1rem',
              backgroundColor: colors.primary.teal,
              color: 'white',
              border: 'none',
              borderRadius: '0.25rem',
              cursor: 'pointer',
              fontSize: '0.875rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <Copy size={16} />
            Copier
          </button>
        </div>
      </div>
    </div>
  );
}

export default CopyChargesModal;
